import { CardView, CardViewProps } from "./CardView";
import { twMerge } from "tailwind-merge";

interface Props {
  cardProps: Pick<CardViewProps, "hideCcofChip" | "card">;
  className?: string;
}

const CardBlock = ({ cardProps, className }: Props) => {
  return (
    <div
      className={twMerge(
        "bg-surface-subtle rounded-8 flex items-center gap-3 border px-5 py-3",
        className,
      )}
    >
      <CardView {...cardProps} />
    </div>
  );
};

export default CardBlock;
